<template>
    <div class="kimsa-radio-group">
        <div v-for="item in items" :key="item.value" class="kimsa-radio"
            :class="{ active: value === item.value }" @click="select(item.value)">
            <span class="kimsa-radio-circle" :style="circleStyle(item)" />
            <span class="kimsa-radio-label" :style="labelStyle(item)">{{ item.label || item.name }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: "KimsaRadioGroup",
    props: {
        value: {
            type: [String, Number],
            default: null,
        },
        items: {
            type: Array,
            default: () => [],
        },
    },
    methods: {
        select(value) {
            const vm = this
            if (value === vm.value) return
            vm.$emit('input', value)
            vm.$emit('change', value)
        },
        activeColor(item) {
            return item.color || 'var(--v-primary-base)'
        },
        circleStyle(item) {
            if (this.value !== item.value) return ''
            const color = this.activeColor(item)
            return `background:${color};border-color:${color}`
        },
        labelStyle(item) {
            if (this.value !== item.value) return ''
            return `color:${this.activeColor(item)}`
        },
    },
}
</script>

<style scoped>
.kimsa-radio-group {
    display: flex;
    align-items: center;
    gap: 20px;
}

.kimsa-radio {
    display: flex;
    align-items: center;
    gap: 7px;
    cursor: pointer;
}

.kimsa-radio-circle {
    width: 14px;
    height: 14px;
    border-radius: 50%;
    border: 1.5px solid var(--v-outline2-base);
    flex-shrink: 0;
    transition: background .15s, border-color .15s;
}

.kimsa-radio-label {
    font-size: 12px;
    color: var(--v-txtSecondary-base);
    transition: color .15s;
}

.kimsa-radio.active .kimsa-radio-label {
    font-weight: 500;
}
</style>
